export default __webpack_public_path__ + "static/media/shopifyExtension1.f9edfcb8.svg";